import React from 'react';
import './AboutUs.css'

const AboutUs = () => {
    return (
        <div>
            <h1>
                This is about us page, content comming soon
            </h1>

        </div>
    );
};

export default AboutUs;